
import { defineComponent } from "vue";
import { useAuthStore } from "@/stores/authStore";
export default defineComponent({
	setup() {
		const authStore = useAuthStore();
		const user = authStore.user;
		return {
			user,
			authStore
		};
	},
	name: "NavigationSidebar",
	props: {
		navigationItems: {
			type: Array as () => SidebarNavigationItemType[],
			default: () => [] as SidebarNavigationItemType[]
		},
		isOpen: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			collapsed: false,
			childrenExpanded: [] as string[]
		};
	},
	mounted() {
		this.collapsed = this.isOpen;
	},
	methods: {
		expandChildren(label: string) {
			if (this.childrenExpanded.indexOf(label) > -1) {
				this.childrenExpanded.splice(this.childrenExpanded.indexOf(label), 1);
			} else {
				this.childrenExpanded.push(label);
			}
		}
	},
	computed: {
		filteredNavs(): SidebarNavigationItemType[] {
			return this.navigationItems.filter((item) => {
				return item.type == null;
			});
		},
		filteredBottomNavs(): SidebarNavigationItemType[] {
			return this.navigationItems.filter((item) => {
				return item.type == "bottom";
			});
		},
		active(): string {
			// eslint-disable-next-line
			let items = this.navigationItems.map((item: any) => {
				return item.path;
			});

			let activePath = "";
			for (const i in items) {
				if (this.$route.path.indexOf(items[i]) > -1) {
					activePath = items[i];
				}
			}
			return activePath;
		},
		userRole() {
			if (this.user != null) {
				return this.user.globalRole.name;
			} else {
				return "none";
			}
		}
	},
	watch: {
		isOpen(v) {
			this.collapsed = v;
		}
	}
});
